import { http } from '../http'
import { mockSendCode, mockVerifyCode } from '@/mocks/authMock'

// Вход по e-mail с одноразовым кодом. Только для internal + b2c (см. AppConfig.internalB2C):
// в external авторизация целиком на внешнем auth-сервисе.
//
// Обе ручки отдают плоское тело, без обёртки data — поэтому возвращаем response.data как есть.

/** Успешный ответ send-code. */
export interface SendCodeResponse {
	sent: boolean
	/** Сколько секунд до повторной отправки. Источник истины для таймера — он, а не константа. */
	retry_after?: number
}

/**
 * Пользователь из ответа verify-code. Намеренно не переиспользуем User из @/api/types:
 * там id — строка и флаг называется onboarding_complete, а здесь id числовой и флаг
 * с окончанием -ed. Пока бэкендер не свёл названия, общий тип под это подгонять нельзя.
 */
export interface VerifyCodeUser {
	id: number
	email: string
	plan: string
	onboarding_completed?: boolean
	/** Написание из GET /user — читаем оба, чтобы правка на бэке не сломала вход. */
	onboarding_complete?: boolean
}

export interface VerifyCodeResponse {
	token: string
	/** true — аккаунт создан этим же входом. */
	is_new: boolean
	user: VerifyCodeUser
}

export interface AuthProvider {
	type: string
	url: string
}

export interface AuthProvidersResponse {
	auth_methods: AuthProvider[]
}

export async function sendCode(email: string, terms: boolean): Promise<SendCodeResponse> {
	if (import.meta.env.VITE_AUTH_MOCK) {
		return mockSendCode(email, terms)
	}
	return http.post<SendCodeResponse>('/auth/send-code', { email, terms }).then((response) => response.data)
}

export async function verifyCode(email: string, code: string): Promise<VerifyCodeResponse> {
	if (import.meta.env.VITE_AUTH_MOCK) {
		return mockVerifyCode(email, code)
	}
	// Токен кладём через authStore.loginWithToken(), user — только чтобы выбрать цель редиректа.
	return http.post<VerifyCodeResponse>('/auth/verify-code', { email, code }).then((response) => response.data)
}

/** Онбординг пройден по данным входа? undefined — бэк флаг не прислал. */
export function isOnboardingCompleted(user: VerifyCodeUser | undefined): boolean | undefined {
	return user?.onboarding_completed ?? user?.onboarding_complete
}

export async function getAuthProviders(): Promise<AuthProvidersResponse> {
	return http.get<AuthProvidersResponse>('/auth/get-providers').then((response) => response.data)
}

/** Обмен одноразового тикета из /auth/callback?code= на токен. Ответ — как у verify-code. */
export async function oauthExchange(code: string): Promise<VerifyCodeResponse> {
	return http.post<VerifyCodeResponse>('/auth/oauth/exchange', { code }).then((response) => response.data)
}
